// extracted by mini-css-extract-plugin
export default {"root":"GCzA3q","content":"TnW2VG","inputSection":"WIDmrJ","templatesSection":"cDR5GV"};